import React, { useEffect, useState } from 'react';

export default function GooglyEyes(props) {
	useEffect(() => {
		document
			.querySelectorAll('.pupil')
			.forEach(
				(p) => (p.style.transform = `translate(${props.X}%, ${props.Y}%)`)
			);
	}, [props.X, props.Y]);

	const [lPupilSwell, setLPupilSwell] = useState('pupil');
	const [rPupilSwell, setRPupilSwell] = useState('pupil');
	useEffect(() => {
		if (props.eyeSweller === 0) {
			setLPupilSwell('pupil swell');
			setTimeout(() => {
				setRPupilSwell('pupil swell');
			}, 88);
			setTimeout(() => {
				setLPupilSwell('pupil');
				setRPupilSwell('pupil');
			}, 588);
		} else {
			setRPupilSwell('pupil swell');
			setTimeout(() => {
				setLPupilSwell('pupil swell');
			}, 88);
			setTimeout(() => {
				setRPupilSwell('pupil');
				setLPupilSwell('pupil');
			}, 588);
		}
	}, [props.eyeSweller]);

	return (
		<div className="face">
			<div className="eye left">
				<div className={lPupilSwell}></div>
			</div>
			<div className="eye right">
				<div className={rPupilSwell}></div>
			</div>
		</div>
	);
}
